import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { Brand } from './Brand';
import { BrandButton } from './BrandButton';
import { navLinks } from '../data/navigation';
export function StickyNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);
  return <header className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${scrolled || menuOpen ? 'border-white/10 bg-ink-900/95 backdrop-blur-md' : 'border-transparent bg-ink-900'}`} data-id="element-486" data-mp="xhqjqof5y2qw">
      <nav aria-label="Primary" className="mx-auto flex max-w-content items-center justify-between px-5 py-3 sm:px-8" data-id="element-487" data-mp="207bve2g10hkd">
        <Brand data-id="element-488" data-mp="24yk3mv5mdwvy" />

        <div className="hidden items-center gap-8 lg:flex" data-id="element-489" data-mp="24z3cznh7fcyd">
          <ul className="flex items-center gap-7" data-id="element-490" data-mp="1r76odteqvl6q">
            {navLinks.map(link => <li key={link.to} data-id="element-491" data-mp="1v77c64nqh8qg">
                <NavLink to={link.to} end={link.to === '/'} className={({
              isActive
            }) => `rounded text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand ${isActive ? 'text-brand' : 'text-white/70 hover:text-white'}`} data-id="element-492" data-mp="1v8idlxtpi4ee">
                  {link.label}
                </NavLink>
              </li>)}
          </ul>
          <BrandButton label="Book your free Response Audit" size="sm" data-id="element-493" data-mp="yjsuy5a997rd" />
        </div>

        <button type="button" onClick={() => setMenuOpen(open => !open)} aria-expanded={menuOpen} aria-controls="mobile-menu" aria-label={menuOpen ? 'Close menu' : 'Open menu'} className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/15 text-white transition-colors hover:border-brand/50 hover:text-brand focus:outline-none focus-visible:ring-2 focus-visible:ring-brand lg:hidden" data-id="element-494" data-mp="13i48or3o82ev">
          {menuOpen ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-495" data-mp="2mdeac98927of" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-496" data-mp="2het9c7l6bjyx" />}
        </button>
      </nav>

      {menuOpen && <div id="mobile-menu" className="border-t border-white/10 bg-ink-900 lg:hidden" data-id="element-497" data-mp="2cjdzdqqae87s">
          <ul className="mx-auto max-w-content px-5 py-3 sm:px-8" data-id="element-498" data-mp="apy8csqaerca">
            {navLinks.map(link => <li key={link.to} className="border-b border-white/5 last:border-b-0" data-id="element-499" data-mp="6omfmec49pzv">
                <NavLink to={link.to} end={link.to === '/'} className={({
            isActive
          }) => `block rounded py-3.5 text-base font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand ${isActive ? 'text-brand' : 'text-white/80 hover:text-white'}`} data-id="element-500" data-mp="1olzgcou4hupv">
                  {link.label}
                </NavLink>
              </li>)}
          </ul>
          <div className="mx-auto max-w-content px-5 pb-5 sm:px-8" data-id="element-501" data-mp="1an84za6nan5f">
            <BrandButton label="Book your free Response Audit" className="w-full" data-id="element-502" data-mp="1eo1sw3k381yb" />
          </div>
        </div>}
    </header>;
}